import React from 'react';
import { Phone, FileText } from 'lucide-react';
export function CategoryHero() {
  return <div className="bg-brand-cream border-b border-brand-border py-8 lg:py-12" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4" data-id="element-20">
        {/* Breadcrumbs */}
        <nav className="flex text-sm text-gray-500 mb-6" data-id="element-21">
          <ol className="flex items-center space-x-2" data-id="element-22">
            <li data-id="element-23">
              <a href="/Home.html" className="hover:text-brand-green transition-colors" data-id="element-24">
                Home
              </a>
            </li>
            <li data-id="element-25">
              <span data-id="element-26">/</span>
            </li>
            <li data-id="element-27">
              <span className="text-gray-400" data-id="element-28">Commercial</span>
            </li>
            <li data-id="element-29">
              <span data-id="element-30">/</span>
            </li>
            <li className="text-brand-charcoal font-medium" data-id="element-31">
              Commercial Mailboxes & Lockers
            </li>
          </ol>
        </nav>

        <div className="max-w-3xl" data-id="element-32">
          <h1 className="text-3xl lg:text-5xl font-serif font-bold text-brand-charcoal mb-4" data-id="element-33">
            Commercial Mailboxes & Lockers
          </h1>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-34">
            Shop centralized delivery mailboxes, CBUs, 4C systems, parcel
            lockers, private delivery boxes, collection boxes, and replacement
            commercial parts — with help before you order.
          </p>

          <div className="flex flex-wrap items-center gap-4" data-id="element-35">
            <a href="#products" className="bg-brand-green hover:bg-brand-green/90 text-white px-6 py-3 rounded-md font-semibold transition-colors shadow-sm" data-id="element-36">
              Shop products
            </a>
            <a href="/ContactUs.html" className="bg-white border border-brand-border hover:border-brand-green text-brand-charcoal px-6 py-3 rounded-md font-semibold flex items-center gap-2 transition-colors shadow-sm" data-id="element-37">
              <FileText size={18} className="text-brand-green" data-id="element-38" /> Request
              project help
            </a>
            <span className="hidden sm:inline text-gray-400" data-id="element-39">or</span>
            <a href="tel:301-620-7585" className="text-brand-green hover:text-brand-charcoal font-semibold flex items-center gap-2 transition-colors" data-id="element-40">
              <Phone size={18} data-id="element-41" /> Call 301-620-7585
            </a>
          </div>
        </div>
      </div>
    </div>;
}